import type { ChoixDePriorite } from '../partage/api/types';
import { CHOIX_DE_PRIORITE } from '../partage/vocabulaire';
import './SelecteurPriorite.css';

/**
 * L'importance d'une bulle, réglée à la main (chantier `flottaison`, décision d'Igor du
 * 2026-10-01) : quatre crans, Quand tu veux, Non réglée, Important, Urgent. « Non réglée »
 * ramène à rien : la bulle prend alors celle d'une mère marquée, s'il y en a une. Plus
 * d'« Auto » : Nextilt ne classe plus rien de lui-même.
 *
 * À ne jamais confondre avec le rang, qui dit dans quel ordre TU construis ton projet.
 */
export function SelecteurPriorite({
  valeur,
  onChoisir,
}: {
  valeur: ChoixDePriorite | null;
  onChoisir: (choix: ChoixDePriorite | null) => void;
}) {
  return (
    <div className="selecteur-priorite" role="group" aria-label="son importance">
      {CHOIX_DE_PRIORITE.map(([choix, mot]) => (
        <button
          key={mot}
          type="button"
          className={valeur === choix ? 'est-choisi' : ''}
          aria-pressed={valeur === choix}
          onClick={() => {
            if (valeur !== choix) onChoisir(choix);
          }}
        >
          {mot}
        </button>
      ))}
    </div>
  );
}
